import { useState } from 'react';
import { Mail, MailX } from 'lucide-react';
import { SegmentedControl } from '../components/common/SegmentedControl';
import { MailLogView } from '../components/messaging/MailLogView';
import { MailSuppressionList } from '../components/messaging/MailSuppressionList';
import { useInTabbedPage } from '../components/common/TabbedPage';

type Tab = 'messages' | 'suppressed';

/**
 * Settings-level view of everything the application sent (administrators):
 * the whole mail log, and the addresses it no longer emails.
 */
export function MailLogPage() {
  const [tab, setTab] = useState<Tab>('messages');
  const embedded = useInTabbedPage();
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        {!embedded && <h1 className="text-2xl font-bold">Mail log</h1>}
        <SegmentedControl
          ariaLabel="Mail log view"
          value={tab}
          onChange={setTab}
          options={[
            { id: 'messages', label: 'Messages', icon: <Mail size={14} /> },
            { id: 'suppressed', label: 'Suppressed addresses', icon: <MailX size={14} /> },
          ]}
        />
      </div>
      {tab === 'messages' ? <MailLogView /> : <MailSuppressionList />}
    </div>
  );
}
